import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Pencil } from "lucide-react";

export const EditableText = ({ value, onSave, disabled, testId }) => {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState(value || "");
  const commit = () => { setEdit(false); if (v.trim() && v !== value) onSave(v.trim()); else setV(value || ""); };
  if (edit) {
    return (
      <Input autoFocus value={v} onChange={(e) => setV(e.target.value)} onBlur={commit} className="h-7 text-xs"
             onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") { setV(value || ""); setEdit(false); } }}
             data-testid={`${testId}-input`} />
    );
  }
  return (
    <button type="button" disabled={disabled} onClick={() => { setV(value || ""); setEdit(true); }} title={disabled ? value : "Clicca per modificare"}
            className="group w-full text-left flex items-center gap-1 truncate disabled:cursor-text" data-testid={testId}>
      <span className="truncate">{value}</span>
      {!disabled && <Pencil className="w-3 h-3 opacity-0 group-hover:opacity-60 shrink-0" />}
    </button>
  );
};
